module.exports = __webpack_public_path__ + "static/media/events.caf3743b.svg";